module.exports = __webpack_public_path__ + "static/media/md-business.6b54fc90.svg";